import { FC } from 'react';
import { IBuildOptionReport } from '../../models';
import { ExternalLink, Modal } from '../../components';
import { Box, Button, Fade, Stack } from '@mui/material';
import { Download } from '@mui/icons-material';

interface IBuildSelectedOptionsPDFModal {
  open: boolean;
  onClose: () => void;
  currentReport: IBuildOptionReport;
}

export const BuildSelectedOptionsPDFModal: FC<IBuildSelectedOptionsPDFModal> = ({
  open,
  onClose,
  currentReport
}) => {
  return (
    <Modal
      title="Download Build Report PDF"
      open={open}
      onClose={() => {
        onClose();
      }}
      maxWidth="xs"
    >
      <Fade in={open}>
        <Box mt={1}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            {currentReport?.buildSelectedOptionsPdfUrl && (
              <ExternalLink to={currentReport?.buildSelectedOptionsPdfUrl} target="_blank">
                <Button
                  id="pdf-with-images"
                  color="primary"
                  variant="contained"
                  startIcon={<Download />}
                  sx={{ width: { xs: '100%', sm: 'auto' } }}
                  onClick={() => onClose()}
                >
                  With Images
                </Button>
              </ExternalLink>
            )}
            {currentReport?.buildSelectedOptionsSlimPdfUrl && (
              <ExternalLink to={currentReport?.buildSelectedOptionsSlimPdfUrl} target="_blank">
                <Button
                  id="pdf-without-images"
                  color="primary"
                  variant="contained"
                  startIcon={<Download />}
                  sx={{ width: { xs: '100%', sm: 'auto' } }}
                  onClick={() => onClose()}
                >
                  Without Images
                </Button>
              </ExternalLink>
            )}
          </Stack>
        </Box>
      </Fade>
    </Modal>
  );
};
